define('home/views/HomepageCommentsModuleView',[
    'backbone-marionette',

    'home/views/ChannelCardPostView',
    'home/views/FetchingView',
    'home/views/HomepageCommentsModuleEmptyView',

    'home/templates/homepageCommentsModule',
], function (
    Marionette,

    ChannelCardPostView,
    FetchingView,
    HomepageCommentsModuleEmptyView,

    homepageCommentsModuleTemplate
) {
    'use strict';

    var HomepageCommentsModuleView = Marionette.CompositeView.extend({
        template: homepageCommentsModuleTemplate,
        className: 'aside__wrap -padded',
        emptyView: function () {
            return new FetchingView({
                className: 'spinner-small',
            });
        },

        itemView: ChannelCardPostView,
        itemViewContainer: '[data-role=posts]',

        initialize: function (options) {
            options = options || {};
            this.commentsPromise = options.commentsPromise;
        },

        itemViewOptions: function (_item, index) {
            // Only show the first 3 items
            if (index > 2)
                return { className: 'hidden' };
        },

        onDomRefresh: function () {
            // This module supports a promise when the comments are fetched from
            // an external source. We listen to it to know when to replace the
            // fetching state with an empty state, if needed.
            if (this.commentsPromise) {
                var self = this;
                this.commentsPromise.then(function () {
                    if (self.collection.length === 0)
                        self.createEmptyView();
                });
            }
        },

        createEmptyView: function () {
            if (!this._emptyViewCreated) {
                this.emptyView = HomepageCommentsModuleEmptyView;
                this.render();
                this._emptyViewCreated = true;
            }
        },
    });

    return HomepageCommentsModuleView;
});

